// Domain module extracted from lib/api.ts (frontend containment F1).
// Moved verbatim: endpoint paths, methods, payloads, parsing, types and export names
// are unchanged. Import via lib/api.ts, which re-exports this module.
import { request } from './client';

// ── Bug Report ─────────────────────────────────────────────────────────
export interface BugReportAttachment {
  filename: string;
  content_type: string;
  data_b64: string;
}
export const submitBugReport = (data: {
  title: string; body: string; page: string; user_agent: string;
  attachments?: BugReportAttachment[];
}) =>
  request<{ ok: boolean; delivered: boolean; message_id?: string; attachments?: number; error?: string }>(
    '/bug-report', { method: 'POST', body: JSON.stringify(data) },
  );
